export default __webpack_public_path__ + "static/homeservice_2-a5302173c5a09389c67cab06975c32d4.png";